import { Controller } from "@hotwired/stimulus";
import Chart from "chart.js/auto";

export default class extends Controller {
  static targets = ["paymentChart", "thisMonthChart"];

  static values = {
    paidTowardsLoan: Number,
    paidTowardsInterest: Number,
    monthlyPrincipal: Number,
    monthlyInterest: Number,
    graphColor: String,
  };

  connect() {
    this.renderChart(
      this.paymentChartTarget,
      [this.paidTowardsLoanValue, this.paidTowardsInterestValue],
      ["Paid towards loan", "Paid towards interest"],
    );

    this.renderChart(
      this.thisMonthChartTarget,
      [this.monthlyPrincipalValue, this.monthlyInterestValue],
      ["Monthly principal", "Monthly interest"],
    );
  }

  renderChart(canvas, data, labels) {
    const ctx = canvas.getContext("2d");

    const primaryColorDark = this.graphColorValue;
    const primaryColorLight = this.lightenColor(this.graphColorValue, 70);
    const chartColors = [primaryColorDark, primaryColorLight];

    const chart = new Chart(ctx, {
      type: "pie",
      data: {
        labels,
        datasets: [
          {
            data,
            backgroundColor: chartColors,
            borderWidth: 0,
          },
        ],
      },
      options: {
        responsive: true,
        maintainAspectRatio: true,
        plugins: {
          legend: { display: false },
          tooltip: { enabled: false },
        },
      },
    });

    return chart;
  }

  lightenColor(color, percent) {
    const hex = color.replace("#", "");

    let r = parseInt(hex.substring(0, 2), 16);
    let g = parseInt(hex.substring(2, 4), 16);
    let b = parseInt(hex.substring(4, 6), 16);

    r = Math.min(255, r + Math.floor((255 - r) * (percent / 100)));
    g = Math.min(255, g + Math.floor((255 - g) * (percent / 100)));
    b = Math.min(255, b + Math.floor((255 - b) * (percent / 100)));

    return `#${r.toString(16).padStart(2, "0")}${g.toString(16).padStart(2, "0")}${b.toString(16).padStart(2, "0")}`;
  }
}
